// extracted by mini-css-extract-plugin
export var backgroundImageResponsive = "background_image_responsive-module--backgroundImageResponsive--7kB2H";